import { userUid, firestore } from '../../../firebase/'
import { apiSalveInColection, apiDeleteInColection, apiSyncReducer } from 'scorpion-core';

export function salvaCustomForm(customForm) {
    return apiSalveInColection(getColCustomForms(), customForm);
}
export function removeCustomForm(customForm) {
    return apiDeleteInColection(getColCustomForms(), customForm);
}

export function manterSincronizacaoCustomForms(sincronizador) {

    apiSyncReducer(getColCustomForms().where("users." + userUid(), "==", true))(sincronizador)
}

export function carregaCustonForm(uid, syncronisador) {
    apiSyncReducer(getDocCustomForm(uid))(syncronisador);
}

function getColCustomForms() {
    return firestore().collection("CustomForm");
}

function getDocCustomForm(uid) {
    return firestore().collection("CustomForm").doc(uid);
}




// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/api.js